import { withMotion } from '@hoc/withMotion';
import Accordion from '@stories/Components/Global/Accordion/Accordion';
import * as React from 'react';
import S from './AccordionContent.styles';
const AccordionContent = (props) => {
    const openDefault = props.items.find(item => item.openAsDefault);
    return (React.createElement(S.AccordionWrapper, null,
        React.createElement(Accordion, { initialId: openDefault?.id ?? '' }, props.items.map((item) => (React.createElement(Accordion.Item, { key: item.id, id: item.id, title: item.heading },
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: item.content } })))))));
};
export default withMotion(AccordionContent);
